import { defineComponent } from 'vue'
import { useRegionStore } from '@/stores/region-store'

export default defineComponent({
  name: 'LotterySwitcher',
  setup() {
    const regionStore = useRegionStore()

    const toggle = () => {
      regionStore.setLotteryType(regionStore.lotteryType === 'hk' ? 'macau' : 'hk')
    }

    return () => {
      const isHk = regionStore.lotteryType === 'hk'
      return (
        <button
          type="button"
          onClick={toggle}
          class="btn-reset inline-flex items-center justify-center w-[0.44rem] h-[0.44rem] rounded-full border border-solid border-[#07c160] text-[#07c160] text-[0.24rem] leading-none cursor-pointer select-none"
        >
          {isHk ? '港' : '澳'}
        </button>
      )
    }
  },
})
